/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1IndividualpaymentFinancialPeopleMutationRequest,
  PostApiV1IndividualpaymentFinancialPeopleMutationResponse,
  PostApiV1IndividualpaymentFinancialPeople400,
  PostApiV1IndividualpaymentFinancialPeople401,
  PostApiV1IndividualpaymentFinancialPeople500,
} from "../../types/individualPaymentEditorsController/PostApiV1IndividualpaymentFinancialPeople.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1IndividualpaymentFinancialPeople } from "../../clients/individualPaymentEditorsController/postApiV1IndividualpaymentFinancialPeople.ts";

export const postApiV1IndividualpaymentFinancialPeopleMutationKey = () =>
  [{ url: "/api/v1/individualpayment/financial-people" }] as const;

export type PostApiV1IndividualpaymentFinancialPeopleMutationKey = ReturnType<
  typeof postApiV1IndividualpaymentFinancialPeopleMutationKey
>;

export function postApiV1IndividualpaymentFinancialPeopleMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiV1IndividualpaymentFinancialPeopleMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = postApiV1IndividualpaymentFinancialPeopleMutationKey();
  return mutationOptions<
    PostApiV1IndividualpaymentFinancialPeopleMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeople400
      | PostApiV1IndividualpaymentFinancialPeople401
      | PostApiV1IndividualpaymentFinancialPeople500
    >,
    { data?: PostApiV1IndividualpaymentFinancialPeopleMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1IndividualpaymentFinancialPeople(data, config);
    },
  });
}

/**
 * @description Cria o plano com descontos aprovados, parcela de matrícula (pendente com Nosso Número quando há valor; paga zerada quando não) e gera as mensalidades quando a matrícula permite. Bloqueia matrícula em seleção de pagamento. Migrado do legado IndividualPayment/FinancialPersonCreate POST. **(Requer Authorization para autenticação)**
 * @summary Cria o plano financeiro individual (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people}
 */
export function usePostApiV1IndividualpaymentFinancialPeople<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1IndividualpaymentFinancialPeopleMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentFinancialPeople400
        | PostApiV1IndividualpaymentFinancialPeople401
        | PostApiV1IndividualpaymentFinancialPeople500
      >,
      { data?: PostApiV1IndividualpaymentFinancialPeopleMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1IndividualpaymentFinancialPeopleMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1IndividualpaymentFinancialPeopleMutationKey();

  const baseOptions = postApiV1IndividualpaymentFinancialPeopleMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1IndividualpaymentFinancialPeopleMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeople400
      | PostApiV1IndividualpaymentFinancialPeople401
      | PostApiV1IndividualpaymentFinancialPeople500
    >,
    { data?: PostApiV1IndividualpaymentFinancialPeopleMutationRequest },
    TContext
  >;

  return useMutation<
    PostApiV1IndividualpaymentFinancialPeopleMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeople400
      | PostApiV1IndividualpaymentFinancialPeople401
      | PostApiV1IndividualpaymentFinancialPeople500
    >,
    { data?: PostApiV1IndividualpaymentFinancialPeopleMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1IndividualpaymentFinancialPeopleMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeople400
      | PostApiV1IndividualpaymentFinancialPeople401
      | PostApiV1IndividualpaymentFinancialPeople500
    >,
    { data?: PostApiV1IndividualpaymentFinancialPeopleMutationRequest },
    TContext
  >;
}
